import '../Assets/Styles/register.css';
import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Link,useNavigate,useLocation} from 'react-router-dom';

import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { useMediaQuery } from 'react-responsive';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

// Load Actions
import * as AppActions from '../Store/Actions/App';

const menuOptions = [
  { label: 'Painel', value: '/admin/dashboard' },
  { label: 'Seu Perfil', value: '/admin/userProfile' },
  { label: 'Cadastro da Empresa', value: '/admin/companyProfile' },
  { label: 'Usuários', value: '/admin/users' },
  { label: 'Documentos', value: '/admin/documents' },
  { label: 'Cartões de Crédito', value: '/admin/creditcards' },
  { label: 'Direcionamentos', value: '/admin/leads' },
  { label: 'Faturas / Pagamentos', value: '/admin/payments' },
];

// UpdateService dialog component
const SideMenu = (props) => {

// set vars from props
const {
	dialog,
	setDialog,
	masterUser,
	setLoginStatus
} = props;		

const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1024px)' })	
const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

const [loading, setLoading] = React.useState(true); 
const [currentPage, setCurrentPage] = React.useState(true); 

var navigate = useNavigate();

// Set location
const location = useLocation();
const { hash, pathname, search } = location;

const [selectedRoute, setSelectedRoute] = React.useState(pathname);


// console.log("[location]--->"+JSON.stringify(location,null,2));

// Execute when dialog opens
React.useEffect(() => {

	//...
	
  // Runs when UNMOUNT component
  return () => {
    
	// ..
	
  };	
			
},[]);

// Logoff method
const logOut = () => {

	// Set logoff flag
	localStorage.setItem("@estacaodoolho/logged",0);
	
	// Remove userData 
	localStorage.removeItem("@estacaodoolho/userData");	
	
	setLoginStatus(false);
	navigate("/");
	
}	


const op = React.useRef(null);

	/* Logout prompt START  */
    const accept = (e) => {
	   logOut();

    };

    const reject = (e) => {
       
    };
	
    const confirm = (event) => {
        confirmPopup({
            target: event.currentTarget,
            message: <div>Tem certeza que deseja <br /> fazer o logoff e sair?</div>,
            icon: 'pi pi-exclamation-triangle',
			accept,
            reject,
			rejectLabel:"Não",
			acceptLabel:"Sim",
            acceptClassName: 'filledButton',
            rejectClassName: 'textButton'			
        });
    };
	/* Logout prompt END  */	
	
	return (
	<>
						{isMobile && (
						<div style={{ margin: '1rem 0',width:"100%" }}>
							<label className="w100 tAlignL" style={{marginBottom:"0.5rem",display:"block"}}>Navegação da área administrativa</label>
							<Dropdown
							value={selectedRoute}
							options={menuOptions}
							onChange={(e) => {
								setSelectedRoute(e.value);
								navigate(e.value);
							}}
							placeholder="Ir para..."
							className="w100"
							/>
						</div>
						)}	

						{!isMobile &&
						<>
						<div style={{width:"220px",alignSelf:"stretch",borderRadius:"8px"}}>
						
							<div style={{position:"sticky",top:"70px",backgroundColor:"#fff",borderRadius:"8px",padding:"10px"}} >
						 										
							
							<Button onClick={(e)=>{navigate("/admin/dashboard")}} className={pathname == "/admin/dashboard" ? "adminButtonLabel first selected" : "adminButtonLabel first"} label="Painel" icon={<svg viewBox="0 0 24 24" width="24" height="24" style={{marginRight:"9px"}}  fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M2.55078 4.5C2.61472 3.84994 2.75923 3.41238 3.08582 3.08579C3.67161 2.5 4.61442 2.5 6.50004 2.5C8.38565 2.5 9.32846 2.5 9.91425 3.08579C10.5 3.67157 10.5 4.61438 10.5 6.5C10.5 8.38562 10.5 9.32843 9.91425 9.91421C9.32846 10.5 8.38565 10.5 6.50004 10.5C4.61442 10.5 3.67161 10.5 3.08582 9.91421C2.77645 9.60484 2.63047 9.19589 2.56158 8.60106" stroke={pathname == "/admin/dashboard" ? "#C53F84" : "#2E0249"}  stroke-width="1.5" stroke-linecap="round"></path> <path d="M21.4493 15.5C21.3853 14.8499 21.2408 14.4124 20.9142 14.0858C20.3284 13.5 19.3856 13.5 17.5 13.5C15.6144 13.5 14.6716 13.5 14.0858 14.0858C13.5 14.6716 13.5 15.6144 13.5 17.5C13.5 19.3856 13.5 20.3284 14.0858 20.9142C14.6716 21.5 15.6144 21.5 17.5 21.5C19.3856 21.5 20.3284 21.5 20.9142 20.9142C21.2408 20.5876 21.3853 20.1501 21.4493 19.5" stroke={pathname == "/admin/dashboard" ? "#C53F84" : "#2E0249"}  stroke-width="1.5" stroke-linecap="round"></path> <path d="M2.5 17.5C2.5 15.6144 2.5 14.6716 3.08579 14.0858C3.67157 13.5 4.61438 13.5 6.5 13.5C8.38562 13.5 9.32843 13.5 9.91421 14.0858C10.5 14.6716 10.5 15.6144 10.5 17.5C10.5 19.3856 10.5 20.3284 9.91421 20.9142C9.32843 21.5 8.38562 21.5 6.5 21.5C4.61438 21.5 3.67157 21.5 3.08579 20.9142C2.5 20.3284 2.5 19.3856 2.5 17.5Z" stroke={pathname == "/admin/dashboard" ? "#C53F84" : "#2E0249"}  stroke-width="1.5"></path> <path d="M13.5 6.5C13.5 4.61438 13.5 3.67157 14.0858 3.08579C14.6716 2.5 15.6144 2.5 17.5 2.5C19.3856 2.5 20.3284 2.5 20.9142 3.08579C21.5 3.67157 21.5 4.61438 21.5 6.5C21.5 8.38562 21.5 9.32843 20.9142 9.91421C20.3284 10.5 19.3856 10.5 17.5 10.5C15.6144 10.5 14.6716 10.5 14.0858 9.91421C13.5 9.32843 13.5 8.38562 13.5 6.5Z" stroke={pathname == "/admin/dashboard" ? "#C53F84" : "#2E0249"} stroke-width="1.5"></path> </g></svg>} text />
										
							
							<Button onClick={(e)=>{navigate("/admin/userProfile")}} className={pathname == "/admin/userProfile" ? "adminButtonLabel selected" : "adminButtonLabel"}  label="Seu Perfil de usuário" icon={<svg width="24" height="24" viewBox="0 0 24 24" style={{marginRight:"9px"}} fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12C2 14.9 3.25 17.51 5.23 19.34C5.23 19.35 5.23 19.35 5.22 19.36C5.32 19.46 5.44 19.54 5.54 19.63C5.6 19.68 5.65 19.73 5.71 19.77C5.89 19.92 6.09 20.06 6.28 20.2C6.35 20.25 6.41 20.29 6.48 20.34C6.67 20.47 6.87 20.59 7.08 20.7C7.15 20.74 7.23 20.79 7.3 20.83C7.5 20.94 7.71 21.04 7.93 21.13C8.01 21.17 8.09 21.21 8.17 21.24C8.39 21.33 8.61 21.41 8.83 21.48C8.91 21.51 8.99 21.54 9.07 21.56C9.31 21.63 9.55 21.69 9.79 21.75C9.86 21.77 9.93 21.79 10.01 21.8C10.29 21.86 10.57 21.9 10.86 21.93C10.9 21.93 10.94 21.94 10.98 21.95C11.32 21.98 11.66 22 12 22C12.34 22 12.68 21.98 13.01 21.95C13.05 21.95 13.09 21.94 13.13 21.93C13.42 21.9 13.7 21.86 13.98 21.8C14.05 21.79 14.12 21.76 14.2 21.75C14.44 21.69 14.69 21.64 14.92 21.56C15 21.53 15.08 21.5 15.16 21.48C15.38 21.4 15.61 21.33 15.82 21.24C15.9 21.21 15.98 21.17 16.06 21.13C16.27 21.04 16.48 20.94 16.69 20.83C16.77 20.79 16.84 20.74 16.91 20.7C17.11 20.58 17.31 20.47 17.51 20.34C17.58 20.3 17.64 20.25 17.71 20.2C17.91 20.06 18.1 19.92 18.28 19.77C18.34 19.72 18.39 19.67 18.45 19.63C18.56 19.54 18.67 19.45 18.77 19.36C18.77 19.35 18.77 19.35 18.76 19.34C20.75 17.51 22 14.9 22 12ZM16.94 16.97C14.23 15.15 9.79 15.15 7.06 16.97C6.62 17.26 6.26 17.6 5.96 17.97C4.44 16.43 3.5 14.32 3.5 12C3.5 7.31 7.31 3.5 12 3.5C16.69 3.5 20.5 7.31 20.5 12C20.5 14.32 19.56 16.43 18.04 17.97C17.75 17.6 17.38 17.26 16.94 16.97Z" fill={pathname == "/admin/userProfile" ? "#C53F84" : "#2E0249"}/>
								<path d="M12 6.92969C9.93 6.92969 8.25 8.60969 8.25 10.6797C8.25 12.7097 9.84 14.3597 11.95 14.4197C11.98 14.4197 12.02 14.4197 12.04 14.4197C12.06 14.4197 12.09 14.4197 12.11 14.4197C12.12 14.4197 12.13 14.4197 12.13 14.4197C14.15 14.3497 15.74 12.7097 15.75 10.6797C15.75 8.60969 14.07 6.92969 12 6.92969Z" fill={pathname == "/admin/userProfile" ? "#C53F84" : "#2E0249"} fill-opacity="0.8"/>
								</svg>} text />
							 
							<Button onClick={(e)=>{navigate("/admin/companyProfile")}} className={pathname == "/admin/companyProfile" ? "adminButtonLabel selected" : "adminButtonLabel"} label="Cadastro da Empresa" icon={<svg viewBox="0 0 24 24" width="24" height="24" style={{marginRight:"9px"}} xmlns="http://www.w3.org/2000/svg" fill={pathname == "/admin/companyProfile" ? "#C53F84" : "#2E0249"} fill-opacity="0.8"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill={pathname == "/admin/companyProfile" ? "#C53F84" : "#2E0249"} fill-opacity="0.8" d="M5 5h2v2H5V5Zm2 3H5v2h2V8Zm-2 3h2v2H5v-2Zm6-6H9v2h2V5ZM9 8h2v2H9V8Zm2 3H9v2h2v-2Z"></path><path fill={pathname == "/admin/companyProfile" ? "#C53F84" : "#2E0249"} fill-opacity="0.8" fill-rule="evenodd" d="M2 19a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9v-3H7v3H2Zm1-2V3h10v14h-2v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1H3Zm13-2h-1v-2h1v2Zm0-4h-1V9h1v2Z"></path></g></svg>} text />

							<Button onClick={(e)=>{navigate("/admin/users")}} className={pathname == "/admin/users" ? "adminButtonLabel selected" : "adminButtonLabel"}  label="Usuários" icon={<svg fill={pathname == "/admin/users" ? "#C53F84" : "#2E0249"} height="24" width="24"  style={{marginRight:"9px"}} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.001 512.001" xmlSpace="preserve" stroke="#2E0249">
							  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
							  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
							  <g id="SVGRepo_iconCarrier">
								<g>
								  <g>
									<path d="M375.071,86.028c-11.366,0-22.143,2.561-31.796,7.122c3.686,4.748,6.998,9.802,9.882,15.121 c2.828,5.216,5.244,10.688,7.214,16.364c3.928,11.321,6.069,23.469,6.069,36.109c0,12.639-2.141,24.788-6.069,36.108 c-1.969,5.678-4.386,11.147-7.214,16.364c-2.884,5.319-6.195,10.372-9.882,15.121c9.653,4.56,20.43,7.123,31.796,7.123 c41.199,0.002,74.716-33.516,74.716-74.714C449.787,119.545,416.27,86.028,375.071,86.028z"></path>
								  </g>
								</g>
								<g>
								  <g>
									<path d="M375.071,271.182c-4.42,0-8.827,0.218-13.206,0.641c6.82,5.311,13.237,11.115,19.187,17.369 c6.005,6.311,11.53,13.079,16.534,20.237c16.349,23.386,27.066,50.987,30.146,80.823c0.607,5.873,0.92,11.83,0.92,17.86 c0,6.261-1.09,12.27-3.072,17.86h68.56c9.864,0,17.86-7.998,17.86-17.86C512.001,332.608,450.574,271.182,375.071,271.182z"></path>
								  </g>
								</g>
								<g>
								  <g>
									<path d="M151.632,196.855c-3.928-11.32-6.069-23.469-6.069-36.108c0-12.64,2.141-24.788,6.069-36.109 c1.971-5.68,4.386-11.15,7.214-16.366c2.884-5.319,6.195-10.372,9.882-15.121c-9.653-4.56-20.43-7.122-31.796-7.122 c-41.199,0-74.716,33.517-74.716,74.716c0,41.198,33.517,74.716,74.716,74.716c11.366,0,22.143-2.562,31.796-7.123 c-3.686-4.749-6.998-9.802-9.882-15.121C156.018,208.002,153.602,202.532,151.632,196.855z"></path>
								  </g>
								</g>
								<g>
								  <g>
									<path d="M136.93,271.182C61.427,271.182,0,332.608,0,408.112c0,9.863,7.997,17.86,17.86,17.86h68.56 c-1.981-5.59-3.071-11.6-3.071-17.86c0-6.031,0.313-11.988,0.919-17.86c3.08-29.836,13.797-57.437,30.146-80.823 c5.005-7.158,10.529-13.926,16.534-20.237c5.95-6.254,12.367-12.058,19.187-17.369C145.757,271.4,141.35,271.182,136.93,271.182z"></path>
								  </g>
								</g>
								<g>
								  <g>
									<path d="M325.393,133.094c-2.509-6.271-5.831-12.13-9.857-17.433c-13.657-17.988-35.257-29.633-59.535-29.633 s-45.878,11.645-59.535,29.635c-4.026,5.303-7.348,11.162-9.857,17.433c-3.421,8.559-5.325,17.883-5.325,27.649 c0,9.765,1.904,19.089,5.325,27.648c2.509,6.271,5.831,12.13,9.857,17.433c13.657,17.988,35.257,29.634,59.535,29.634 s45.878-11.646,59.535-29.636c4.026-5.303,7.348-11.162,9.857-17.433c3.421-8.559,5.325-17.882,5.325-27.648 S328.814,141.653,325.393,133.094z"></path>
								  </g>
								</g>
								<g>
								  <g>
									<path d="M391.768,390.252c-4.11-31.402-18.901-59.488-40.594-80.489c-5.137-4.971-10.656-9.547-16.515-13.672 c-6.044-4.256-12.444-8.04-19.149-11.288c-12.892-6.246-26.905-10.528-41.647-12.457v111.953c0,9.863-7.997,17.86-17.86,17.86 c-9.864,0-17.86-7.998-17.86-17.86V272.346c-14.743,1.929-28.755,6.211-41.648,12.457c-6.705,3.249-13.105,7.032-19.149,11.288 c-5.859,4.126-11.38,8.702-16.515,13.672c-21.695,21-36.485,49.087-40.594,80.489c-0.764,5.846-1.163,11.807-1.163,17.86 c0,9.863,7.997,17.86,17.86,17.86h238.14c9.864,0,17.86-7.998,17.86-17.86C392.933,402.059,392.534,396.098,391.768,390.252z"></path>
								  </g>
								</g>
							  </g>
							</svg>
							} text />

							<Button
							onClick={() => navigate("/admin/documents")}
							className={pathname === "/admin/documents" ? "adminButtonLabel selected" : "adminButtonLabel"}
							label="Documentos"
							icon={
								<svg
								version="1.1"
								width="24"
								height="24"
								viewBox="0 0 682.66669 682.66669"
								xmlns="http://www.w3.org/2000/svg"
								xmlnsXlink="http://www.w3.org/1999/xlink"
								style={{ marginRight: "8px" }}
								>
								<g transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)">
									<g>
									<g>
										<g>
										<path
											d="M 0,512 H 512 V 0 H 0 Z"
											fill="none"
										/>
										</g>
										<g transform="translate(62.4766,208.397)">
										<path
											d="m 0,0 -54.684,152.013 c -0.939,2.649 0.456,5.582 3.105,6.55 28.936,10.394 59.126,20.561 89.601,30.812 M 328.043,-107.73 153.341,-170.523 76.67,-198.089 c -2.648,-0.969 -5.582,0.427 -6.55,3.075 L 11.506,-31.98"
											fill="none"
											stroke={pathname === "/admin/documents" ? "#c53f84" : "#2e0249"}
											strokeWidth="15"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										</g>
										<g transform="translate(425.0669,106.5903)">
										<path
											d="m 0,0 -181.423,-31.098 -80.317,-13.783 c -2.762,-0.455 -5.439,1.424 -5.924,4.187 l -29.648,173 -32.668,190.458 c -0.484,2.79 1.396,5.439 4.158,5.923 l 91.538,15.691"
											fill="none"
											stroke={pathname === "/admin/documents" ? "#c53f84" : "#2e0249"}
											strokeWidth="15"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										</g>
										<g transform="translate(190.7827,295.0542)">
										<path
											d="m 0,0 v 201.621 c 0,2.933 2.393,5.325 5.326,5.325 h 238.129 3.987 c 1.623,0 2.079,-0.655 4.842,-3.275 l 58.414,-55.702 c 2.364,-2.307 3.019,-2.563 3.019,-4.101 v -3.303 -237.645 -86.03 c 0,-2.933 -2.392,-5.354 -5.325,-5.354 H 90.342 5.326 c -2.933,0 -5.326,2.421 -5.326,5.354 v 148.311"
											fill="none"
											stroke={pathname === "/admin/documents" ? "#c53f84" : "#2e0249"}
											strokeWidth="15"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										</g>
										<g transform="translate(434.2378,502)">
										<path
											d="m 0,0 0.114,-52.826 c 0,-11.818 10.823,-11.077 16.034,-11.077 h 54.114"
											fill="none"
											stroke={pathname === "/admin/documents" ? "#c53f84" : "#2e0249"}
											strokeWidth="15"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										</g>
										{[
										393.0449,
										339.7637,
										286.4824,
										233.2012,
										179.9194,
										].map((y, i) => (
										<g key={i} transform={`translate(456.3672,${y})`}>
											<path
											d="M 0,0 H -214.433"
											fill="none"
											stroke={pathname === "/admin/documents" ? "#c53f84" : "#2e0249"}
											strokeWidth="15"
											strokeLinecap="round"
											strokeLinejoin="round"
											/>
										</g>
										))}
									</g>
									</g>
								</g>
								</svg>
							}
							text
							/>							
							
							<Button
							onClick={() => navigate("/admin/creditcards")}
							className={pathname === "/admin/creditcards" ? "adminButtonLabel selected" : "adminButtonLabel"}
							label="Cartões de Crédito"
							icon={
								<svg
								width="24"
								height="24"
								viewBox="0 0 50 50"
								xmlns="http://www.w3.org/2000/svg"
								style={{ marginRight: "8px" }}
								>
								<g
									stroke={pathname === "/admin/creditcards" ? "#C53F84" : "#2E0249"}
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeMiterlimit="10"
									strokeWidth="2"
								>
									<g>
									<path
										d="M1.75 16.547h5.102v5.127H1.75z"
										fill={pathname === "/admin/creditcards" ? "#C53F84" : "#2E0249"}
									/>
									<path
										d="M43.15 14.876v-2.356c0-1.118-.915-2.033-2.033-2.033H3.785c-1.128 0-2.033.915-2.033 2.033v21.322c0 1.128.905 2.033 2.033 2.033h3.07"
										fill="none"
									/>
									</g>
									<path
									d="M6.852 20.182h41.398v5.127H6.852z"
									fill={pathname === "/admin/creditcards" ? "#C53F84" : "#2E0249"}
									/>
									<g fill="none">
									<path
										d="M8.885 39.513c-1.123 0-2.033-.91-2.033-2.033V16.908c0-1.123.91-2.033 2.033-2.033h37.332c1.123 0 2.033.91 2.033 2.033v20.571c0 1.123-.91 2.033-2.033 2.033H8.885z"
									/>
									<path d="M11.997 30.37h9.341" />
									<path d="M11.997 35.43h.586" />
									<path d="M16.667 35.43h.586" />
									<path d="M21.338 35.43h.585" />
									</g>
									<circle
									cx="41.284"
									cy="33.273"
									r="2.489"
									fill={pathname === "/admin/creditcards" ? "#C53F84" : "#2E0249"}
									/>
									<circle
									cx="37.372"
									cy="33.273"
									r="2.489"
									fill="#ffffff"
									/>
								</g>
								</svg>
							}
							text
							/>
							
							<Button
							onClick={() => navigate("/admin/leads")}
							className={pathname === "/admin/leads" ? "adminButtonLabel selected" : "adminButtonLabel"}
							label="Direcionamentos"
							icon={
								<svg
								width="24"
								height="24"
								viewBox="0 0 512 512"
								xmlns="http://www.w3.org/2000/svg"
								style={{ marginRight: "8px" }}
								>
								<path
									d="M440.854 198.719H71.145c-7.532 0-13.66 6.128-13.66 13.661v30.1c0 7.532 6.128 13.661 13.66 13.661h9.373l129.922 128.331v89.117c0 2.681 1.343 5.183 3.576 6.666 1.331.883 2.873 1.334 4.425 1.334 1.052 0 2.108-.208 3.106-.628l75.119-31.66c2.965-1.25 4.893-4.154 4.893-7.372v-57.458l129.922-128.331h9.373c7.533 0 13.661-6.128 13.661-13.661v-30.1c.001-7.532-6.127-13.66-13.661-13.66zM226.44 461.536v-72.407h59.119v47.491zm63.835-88.407h-68.549L103.286 256.14h305.427zM438.516 239.549H73.484v-25.421h365.032v25.421zM185.835 180.16h140.329c2.27 0 4.433-.964 5.95-2.653 1.518-1.688 2.246-3.941 2.004-6.199-3.21-29.993-22.914-54.452-49.556-64.8 9.251-8.016 15.12-19.835 15.12-33.007 0-24.086-19.596-43.681-43.682-43.681s-43.682 19.595-43.682 43.681c0 13.172 5.869 24.992 15.119 33.007-26.642 10.347-46.347 34.807-49.557 64.801-.242 2.257.486 4.51 2.004 6.198 1.518 1.689 3.681 2.653 5.951 2.653zm42.483-106.659c0-15.264 12.418-27.681 27.682-27.681s27.682 12.417 27.682 27.681-12.418 27.681-27.682 27.681-27.682-12.417-27.682-27.681zm27.682 43.681c29.011 0 53.669 19.656 60.621 46.978H195.678c6.952-27.322 31.611-46.978 60.622-46.978zm247.954 54.126c-3.21-29.993-22.915-54.452-49.556-64.8 9.25-8.016 15.119-19.835 15.119-33.007 0-24.086-19.595-43.681-43.681-43.681s-43.682 19.595-43.682 43.681c0 13.172 5.869 24.991 15.119 33.007-26.643 10.347-46.348 34.807-49.558 64.801-.242 2.257.486 4.51 2.004 6.198s3.681 2.653 5.95 2.653h140.33c2.27 0 4.433-.964 5.95-2.653 1.519-1.688 2.247-3.941 2.005-6.199zm-78.118-125.488c15.264 0 27.681 12.417 27.681 27.681s-12.417 27.681-27.681 27.681-27.682-12.417-27.682-27.681 12.418-27.681 27.682-27.681zm-60.623 118.34c6.952-27.322 31.611-46.978 60.622-46.978s53.67 19.656 60.622 46.978zM191.196 211.425c1.518-1.688 2.246-3.941 2.004-6.199-3.21-29.993-22.915-54.453-49.556-64.8 9.25-8.015 15.119-19.835 15.119-33.007 0-24.086-19.595-43.681-43.681-43.681s-43.682 19.595-43.682 43.681c0 13.172 5.869 24.992 15.119 33.007-26.642 10.348-46.347 34.807-49.556 64.801-.242 2.257.486 4.51 2.004 6.199 1.518 1.688 3.681 2.652 5.95 2.652h140.329c2.27 0 4.433-.964 5.95-2.653zM87.4 107.419c0-15.264 12.418-27.681 27.682-27.681s27.681 12.417 27.681 27.681-12.417 27.681-27.681 27.681S87.4 122.683 87.4 107.419zm-32.94 90.659c6.951-27.322 31.61-46.978 60.622-46.978 29.011 0 53.669 19.656 60.621 46.978z"
									fill={pathname === "/admin/leads" ? "#C53F84" : "#2E0249"}
								/>
								</svg>
							}
							text
							/>
	
							<Button
							onClick={() => navigate("/admin/payments")}
							className={pathname === "/admin/payments" ? "adminButtonLabel selected" : "adminButtonLabel"}
							label="Faturas / Pagamentos"
							icon={
								<svg
								width="24"
								height="24"
								viewBox="0 0 64 64"
								xmlns="http://www.w3.org/2000/svg"
								style={{ marginRight: "8px" }}
								>
								<g>
									<path
									d="M63,53H58V10A10.011,10.011,0,0,0,48,0H10A10.011,10.011,0,0,0,0,10a1,1,0,0,0,1,1H18V27.048a1,1,0,1,0,2,0V10a9.98,9.98,0,0,0-4.026-8H48a8.009,8.009,0,0,1,8,8V53H37a1,1,0,0,0-1,1,8,8,0,0,1-15.108,3.675,1,1,0,0,0-1.776.92A9.973,9.973,0,0,0,28,64H54A10.011,10.011,0,0,0,64,54,1,1,0,0,0,63,53ZM17.937,9H2.062A8,8,0,0,1,17.937,9ZM54,62H33.99a10,10,0,0,0,3.96-7H61.937A8.011,8.011,0,0,1,54,62Z"
									fill={pathname === "/admin/payments" ? "#C53F84" : "#2E0249"}
									/>
									<path
									d="M28,26.412H48a1,1,0,0,0,0-2H28a1,1,0,0,0,0,2Z"
									fill={pathname === "/admin/payments" ? "#C53F84" : "#2E0249"}
									/>
									<path
									d="M48,31.079H31a1,1,0,0,0,0,2H48a1,1,0,0,0,0-2Z"
									fill={pathname === "/admin/payments" ? "#C53F84" : "#2E0249"}
									/>
									<path
									d="M48,37.745H35a1,1,0,0,0,0,2H48a1,1,0,0,0,0-2Z"
									fill={pathname === "/admin/payments" ? "#C53F84" : "#2E0249"}
									/>
									<path
									d="M48,44.412H35a1,1,0,0,0,0,2H48a1,1,0,0,0,0-2Z"
									fill={pathname === "/admin/payments" ? "#C53F84" : "#2E0249"}
									/>
									<path
									d="M28,13.079H48a1,1,0,0,0,0-2H28a1,1,0,0,0,0,2Z"
									fill={pathname === "/admin/payments" ? "#C53F84" : "#2E0249"}
									/>
									<path
									d="M28,19.745H48a1,1,0,0,0,0-2H28a1,1,0,0,0,0,2Z"
									fill={pathname === "/admin/payments" ? "#C53F84" : "#2E0249"}
									/>
									<path
									d="M32,42.677a13,13,0,1,0-13,13A13.014,13.014,0,0,0,32,42.677Zm-13,11a11,11,0,1,1,11-11A11.013,11.013,0,0,1,19,53.677Z"
									fill={pathname === "/admin/payments" ? "#C53F84" : "#2E0249"}
									/>
									<path
									d="M17.654,38.643h2.692A1.592,1.592,0,0,1,22,40.16a1,1,0,0,0,2,0,3.592,3.592,0,0,0-3.654-3.517H20V34.677a1,1,0,0,0-2,0v1.966h-.346a3.52,3.52,0,1,0,0,7.034h2.692a1.523,1.523,0,1,1,0,3.034H17.654A1.592,1.592,0,0,1,16,45.194a1,1,0,0,0-2,0,3.592,3.592,0,0,0,3.654,3.517H18v1.966a1,1,0,0,0,2,0V48.711h.346a3.52,3.52,0,1,0,0-7.034H17.654a1.523,1.523,0,1,1,0-3.034Z"
									fill={pathname === "/admin/payments" ? "#C53F84" : "#2E0249"}
									/>
								</g>
								</svg>
							}
							text
							/>
							
							<ConfirmPopup />
							<Button onClick={(e) => {confirm(e)}} className="adminButtonLabel" label="Fazer logoff" icon={<svg viewBox="0 0 24 24" width="24" height="24" style={{marginRight:"9px"}} fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15 12L2 12M2 12L5.5 9M2 12L5.5 15" stroke="#2E0249" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M9.00195 7C9.01406 4.82497 9.11051 3.64706 9.87889 2.87868C10.7576 2 12.1718 2 15.0002 2L16.0002 2C18.8286 2 20.2429 2 21.1215 2.87868C22.0002 3.75736 22.0002 5.17157 22.0002 8L22.0002 16C22.0002 18.8284 22.0002 20.2426 21.1215 21.1213C20.3531 21.8897 19.1752 21.9862 17 21.9983M9.00195 17C9.01406 19.175 9.11051 20.3529 9.87889 21.1213C10.5202 21.7626 11.4467 21.9359 13 21.9827" stroke="#2E0249" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>} text />
							
							</div>
						 
						 
						</div>	
						</>
						}	

	</>	
	);
	
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  masterUser:store.appReducer.masterUser
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(SideMenu);	
